import { Button, Group, Text } from "@mantine/core";
import type { DataTableColumn } from "mantine-datatable";
import BasePage from "../BasePage";
import { useEffect, useState } from "react";
import { coreApi } from "../../utils/CoreAPI";
import { TableOverlay } from "../../components/LoadingOverlay";
import ResponsiveTable from "../../components/ResponsiveTable";
import { IconRefresh } from "@tabler/icons-react";
import Employee from "../../interfaces/Employee";
import { useNavigate } from "react-router";

function ActiveEmployeesPage() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [groupData, setGroupData] = useState<Employee[]>([]);
    const [dataLength, setDataLength] = useState(0);

    const columns: DataTableColumn<Employee>[] = [
        { accessor: "id", title: "ID", sortable: true },
        { accessor: "displayName", title: "Name", sortable: true },
        { accessor: "userPrincipalName", title: "E-Mail", sortable: true },
        { accessor: "jobTitle", title: "Title", sortable: true },
    ];

    const getGroupMembers = async (forceSync = false) => {
        setLoading(true);

        const response = await coreApi.get(
            `/graph/groups/6b5da3c1-b3e7-4556-b3db-b6b5f52580d4/members${forceSync ? "?cache_bust=1" : ""}`
        );

        setGroupData(response.data);
        setDataLength(response.data.length);
        setLoading(false);
    };

    const handleEmployeeViewDetails = (employee: Employee) => {
        navigate(`employee/${employee.id}`, { state: { employee } });
    };

    useEffect(() => {
        getGroupMembers();
    }, []);

    return (
        <BasePage
            breadcrumbs={[{ label: "Active Employees" }]}
            fullWidth
        >
            <TableOverlay visible={loading}>
                <Group
                    justify="space-between"
                    style={{
                        borderBottom: "1px solid var(--border-color)",
                    }}
                >
                    <Group gap={0}>
                        <Button
                            className="unify-btn-subtle unify-border-0"
                            leftSection={<IconRefresh size="1.125rem" />}
                            onClick={() => {
                                getGroupMembers(true);
                            }}
                        >
                            Sync
                        </Button>
                    </Group>

                    <Text size="sm" c="var(--text-dimmed)">
                        {dataLength} employees
                    </Text>
                </Group>

                <ResponsiveTable
                    data={groupData}
                    columns={columns}
                    gridRowId={(row) => row.id}
                    onRowClick={(row) => { handleEmployeeViewDetails(row) }}
                    gridSortModel={{
                        columnAccessor: "displayName",
                        direction: "asc",
                    }}
                    selectionColumnStyle={{ display: 'none' }}
                />
            </TableOverlay>
        </BasePage>
    );
}

export default ActiveEmployeesPage;